var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { from, empty } from 'rxjs';
import { ListingsService } from '../services/listings.service';
import { PreRenderService } from '../services/pre-render.service';
import { CommunicationService } from '../services/communication.service';
import { ListingCategory } from '../classes/enums';
import { catchError, map } from 'rxjs/operators';
import { UrlSanitizerService } from '../services/url-sanitizer.service';
import { UrlValidator } from './url-validator';
var ListingResolver = /** @class */ (function (_super) {
    __extends(ListingResolver, _super);
    function ListingResolver(_listingsService, _communicationService, _urlSanitizerService, _preRenderService, _router) {
        var _this = _super.call(this, _urlSanitizerService, _router, _preRenderService) || this;
        _this._listingsService = _listingsService;
        _this._communicationService = _communicationService;
        _this._urlSanitizerService = _urlSanitizerService;
        _this._preRenderService = _preRenderService;
        _this._router = _router;
        _this.redirectErrorMessage = 'redirected';
        return _this;
    }
    ListingResolver.prototype.resolve = function (route, rstate) {
        var _this = this;
        var url = rstate.root.firstChild.url;
        var listingIdWithBoardPrefix = '0';
        var listingIdRegex = /-(\w+_\w+)-lst/;
        // Example path "address-wp_idm00000001-123456-lst" to extract "wp_idm00000001-123456"
        var listingIdRegexSeventy3 = /-(\w+_\w+-\w+)-lst/;
        var pathToBeChecked = url.length === 4 ? url[3].path : url[2].path;
        var listingIdMatches = listingIdRegex.exec(pathToBeChecked);
        if (listingIdMatches && listingIdMatches.length === 2)
            listingIdWithBoardPrefix = listingIdMatches[1];
        else {
            listingIdMatches = listingIdRegexSeventy3.exec(pathToBeChecked);
            if (listingIdMatches && listingIdMatches.length === 2)
                listingIdWithBoardPrefix = listingIdMatches[1];
        }
        if (!this.isValidUrl(url))
            return empty();
        return from(this._listingsService.getListingDetails(listingIdWithBoardPrefix)).pipe(map(function (listing) {
            if (_this.shouldRedirect(listing)) {
                _this.navigationRedirect(listing.redirectUrl);
                throw new Error(_this.redirectErrorMessage);
            }
            var categoryRedirect = _this.listingCategoryRedirectUrl(listing, url);
            if (categoryRedirect) {
                _this.navigationRedirect(categoryRedirect);
                throw new Error(_this.redirectErrorMessage);
            }
            _this._communicationService.setCurrentListingType(listing.isCommercial ? ListingCategory.COMMERCIAL : listing.isLuxury ? ListingCategory.LUXURY : ListingCategory.RESIDENTIAL);
            return listing;
        }), catchError(function (err) {
            if (err.message !== _this.redirectErrorMessage) {
                var fallbackUrl = url.length === 4 ? url[0] + '/' + url[1] + '/' + url[2] : url[0] + '/' + url[1];
                _this.navigationRedirect(fallbackUrl);
            }
            return empty();
        }));
    };
    ListingResolver.prototype.shouldRedirect = function (listing) {
        return listing.redirectUrl && listing.redirectUrl !== '' && listing.redirectUrl.replace(/\\|\//g, '') !== listing.detailUrl.replace(/\\|\//g, '');
    };
    ListingResolver.prototype.listingCategoryRedirectUrl = function (listing, url) {
        // a 4 segment URL is one that starts with commercial or luxury
        if (listing.isResidential && url.length === 4)
            return url.slice(1).join('/');
        else if (listing.isLuxury && url.length === 3)
            return "/luxury/" + url.join('/');
        else if (listing.isCommercial && url.length === 3)
            return "/commercial/" + url.join('/');
        return undefined;
    };
    return ListingResolver;
}(UrlValidator));
export { ListingResolver };
